import React from "react";
import OMOSettingsLayout from "../layout/OMOSettingsLayout";
import OMOConnectSettingsForm from "../form/OMOConnectSettingsForm";

const OMOAgentSettingPage = () => {

    return (
        <OMOSettingsLayout title="간편 로그인 화면 신청">
            <div className="items-center">
                <div className="flex-col gap-[32px] border bg-white p-[32px] rounded-[16px]">
                    <OMOConnectSettingsForm isConnect={false} />
                </div>
            </div>
        </OMOSettingsLayout>
    );
};
export default OMOAgentSettingPage;
